module.exports = __webpack_public_path__ + "img/showcase-footer.154834ad.png";